
// Video popup
class VideoPopupComponents extends HTMLElement {
  constructor() {
    super();
    this.target = document.querySelector(`#${this.dataset.target}`);
  }

  connectedCallback() {
    this.addEventListener('click', () => {
      this.toggleModel();
      document.body.classList.add('overflow-hidden');
      this.hasAttribute('data-swiperIndexTarget') ? this.swiperVideoPlay() : this.videoPlay();
    });
  }

  swiperVideoPlay() {
    document.querySelectorAll('.js-video-element')[parseInt(this.getAttribute('data-swiperIndexTarget'))].play();
  }

  videoPlay() {
    this.target.querySelector('video').play();
  }

  toggleModel() {
    this.expanded = this.target.getAttribute('aria-expanded');
    this.target.setAttribute('aria-expanded', (this.expanded === 'false').toString());
  }
}

customElements.define('video-popup', VideoPopupComponents);

// Video model
class VideoModelComponents extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelectorAll('.js-model-close');
  }

  connectedCallback() {
    this.closeBtn.forEach((button) => {
      button.addEventListener('click', () => {
        document.body.classList.toggle('overflow-hidden');
        this.toggleModel();
        this.querySelectorAll('video').forEach((video) => {video.pause()});
      });
    });
  }

  toggleModel() {
    this.expanded = this.getAttribute('aria-expanded');
    this.setAttribute('aria-expanded', (this.expanded === 'false').toString());
    document.querySelector(`[data-target="${this.id}"]`).closest('sticky-video').querySelector('video')?.play();
  }
}

customElements.define('video-model', VideoModelComponents);

// Video popup slider
class VideoPopupSliderComponents extends HTMLElement {
  constructor() {
    super();

    this.swiper = this.querySelector('[id^="VideoSwiper-"]');
    this.swiperPrev = this.querySelector('[id^="VideoSwiperPrev-"]');
    this.swiperNext = this.querySelector('[id^="VideoSwiperNext-"]');
    this.swiperVideos = this.querySelectorAll('.js-video-element');
    this.swiperVideoPopups = document.querySelectorAll('.video-popup[data-swiperIndexTarget]');
  }

  connectedCallback() {
    this.initSwiper();
    this.querySelector('.swiper-buttons').addEventListener('click', () => {this.swiperVideosPausePlay()});
  }

  initSwiper() {
    var swiper = new Swiper(this.swiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        prevEl: this.swiperPrev,
        nextEl: this.swiperNext
      }
    });

    if(this.swiperVideoPopups.length == 0) return;
    this.swiperVideoPopups.forEach((popup) => {
      popup.addEventListener('click', () => {
        swiper.slideTo(parseInt(popup.getAttribute('data-swiperIndexTarget')), '300ms', false);
      })
    });
  }

  swiperVideosPausePlay() {
    this.swiperVideos.forEach((video) => {video.pause()});
    this.querySelector('.swiper-slide-active video').play();
  }
}

customElements.define('video-popup-slider', VideoPopupSliderComponents);

// Video columns slider
//old code done by forhad
class ComponentsSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiper = this.querySelector('[id^="Swiper-"]');
    this.swiperPrev = this.querySelector('[id^="SwiperPrev-"]');
    this.swiperNext = this.querySelector('[id^="SwiperNext-"]');
    this.swiperPagination = this.querySelector('[id^="SwiperPagination-"]');
    this.swiperVideos = this.querySelectorAll('.js-video-element');

    this.columnsMobile = parseFloat(this.dataset.columnsMobile);
    this.columnsDesktop = parseFloat(this.dataset.columnsDesktop);

  }

  connectedCallback() {
    this.initSwiper();
    this.swiperPagination.addEventListener('click', () => {this.swiperVideosPausePlay()});
    this.querySelectorAll('.swiper-buttons').forEach(swiperButtons => swiperButtons.addEventListener('click', () => {this.swiperVideosPausePlay()}));

    this.resetHeight();
    this.setSwiperHeight();
    if(this.classList.contains('image-text--swiper') || this.classList.contains('icon-text--swiper')) return;
    window.matchMedia('(max-width: 769px)').matches ? this.swiperNavigations(true): this.swiperNavigations(false);
    window.matchMedia('(max-width: 769px)').addEventListener('change', () => window.matchMedia('(max-width: 769px)').matches ? this.swiperNavigations(true): this.swiperNavigations(false));

    window.addEventListener('resize', () => {
      this.resetHeight();
      this.setSwiperHeight();
    });
  }

  initSwiper() {
    console.log('Init Swiper');
    var swiper = new Swiper(this.swiper, {
      slidesPerView: this.columnsMobile,
      spaceBetween: 20,
      pagination: {
        el: this.swiperPagination,
        clickable: true
      },
      navigation: {
        prevEl: this.swiperPrev,
        nextEl: this.swiperNext
      },
      breakpoints: {
        769: {
          slidesPerView: this.columnsDesktop >= 3 ? 2 : this.columnsDesktop,
          spaceBetween: 30
        },
        1025: {
          slidesPerView: this.columnsDesktop >= 4 ? 3 : this.columnsDesktop,
          spaceBetween: 30
        },
        1440: {
          slidesPerView: this.columnsDesktop,
          spaceBetween: 30
        }
      }
    });
    console.log('Initialized Swiper');
  }

  swiperNavigations(mobile = false) {
    if(!window.matchMedia('(max-width: 1025px)').matches) return;
    this.videoPosterHeight = this.querySelector('.swiper-slide-active .text__video--popup').offsetHeight;
    this.swiperNavigationOffset = mobile ? this.videoPosterHeight - 15: this.videoPosterHeight;
    this.style.setProperty('--swiper-navigation-top-offset', `${this.swiperNavigationOffset / 2}px`);
    if(mobile) this.style.setProperty('--swiper-pagination-top', `${this.swiperNavigationOffset}px`);
  }

  swiperVideosPausePlay() {
    if(!this.querySelector('.swiper-slide-active video')) return;
    this.swiperVideos.forEach((video) => video.pause());
    this.querySelector('.swiper-slide-active video').play();
  }

  setSwiperHeight() {
    const parentElement = this;
    const mutationConfig = { attributes: true, childList: true, subtree: true };
    function onMutationChangeCallack(mutationConfigList) {
      for(const mutationConfig of mutationConfigList) {
        if(mutationConfig.type === 'attributes') {
          parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
          // console.log(`${mutationConfig.attributeName} attribute changed`);
        } else if(mutationConfig.type === 'childList') {
          parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
          // console.log("A child node has been added or removed.");
        } else {
          parentElement.style.setProperty('--swiper-height', `${parentElement.querySelector('.swiper-wrapper').offsetHeight}px`);
          // console.log("A subtree has been added or removed.");
        }
      }
    }

    const observer = new MutationObserver(onMutationChangeCallack);
    observer.observe(this.swiper, mutationConfig);
  }

  resetHeight() {
    return this.style.removeProperty('--swiper-height');
  }
}

customElements.define('component-swiper', ComponentsSwiper);




// sticky video
class StickyVideoComponents extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video');
    this.videoWrapper = this.video.parentElement;
    this.sizeToggle = this.querySelector('.js-toggle-size');
    this.closeBtn = this.querySelector('.js-sticky-video-close');
    this.videoSound = this.querySelector('.js-video-sound-toggle');
    this.cardAddButton = this.querySelector('.video-popup--cart');
    this.videoPopup = this.querySelector('video-popup');
  }

  connectedCallback() {
    this.closeBtn.addEventListener('click', () => {
      this.toggleSticky();
      this.getAttribute('aria-expanded') == 'true' && this.video.pause();
    });

    this.video.addEventListener('click', (event) => event.target !== this.sizeToggle && this.enlargeVideo());
    this.sizeToggle.addEventListener('click', () => this.shrinkSize());
    this.videoSound.addEventListener('click', () => this.toggleVideoSound());
    this.videoPopup.addEventListener('click', () => this.video.pause());
    this.cardAddButton.addEventListener('click', () => {
      this.shrinkSize();
      setTimeout(() => {
        this.toggleSticky();
        this.getAttribute('aria-expanded') == 'true' && this.video.pause();
      }, 400);
    })
    setTimeout(() => this.toggleSticky(), 400);
    // document.addEventListener('DOMContentLoaded', () => this.toggleSticky());
    document.addEventListener('click', (event) => !this.contains(event.target) && this.shrinkSize());
  }

  toggleVideoSound() {
    this.setAttribute('data-muted', !this.video.muted);
    this.video.muted = !this.video.muted;
  }

  toggleSticky() {
    this.expanded = this.getAttribute('aria-expanded');
    this.setAttribute('aria-expanded', (this.expanded === 'false').toString());
  }

  enlargeVideo() {
    setTimeout(() => {
      this.dataset.videoSize = 'large';
      this.videoWrapper.style.width = 'auto';
      this.videoWrapper.style.height = '380px';
      this.setAttribute('data-muted', false);
      this.video.muted = false;
    }, 100);
  }

  shrinkSize() {
    this.videoWrapper.style.width = `${this.videoWrapper.offsetWidth}px`;
    setTimeout(() => {
      this.dataset.videoSize = 'small';
      this.videoWrapper.style.removeProperty('width');
      this.videoWrapper.style.removeProperty('height');
      this.setAttribute('data-muted', true);
      this.video.muted = true;
    }, 100);
  }
}

customElements.define('sticky-video', StickyVideoComponents);

// block slider
class BlockSlider extends HTMLElement{
  constructor() {
    super();
    this.autoPlay = this.dataset.autoplay === 'true';
    this.autoPlayDelay = parseInt(this.dataset.autoplayDelay);
    this.swiperWrapper = this.querySelector('[id^="swiper-"]');

    console.log('hey not work !!')

  }

  connectedCallback() {
    this.initSwiper();
    this.swiper.autoplay.stop();
    this.autoPlay && setTimeout(() => this.swiper.autoplay.start(), this.autoPlayDelay);
  }

  initSwiper() {
    this.swiper = new Swiper(this.swiperWrapper, {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: {
        delay: this.autoPlayDelay
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
    });
  }


}
customElements.define('block-slider', BlockSlider);